export interface Report {
  id: number;
  company: number;
  export?: string;
  number?: string;
  user?: number;
  reportType: string;
  status?: string;
  requestTime?: Date;
  completeTime?: Date;
}

export interface ReportType {
  value: string;
  displayValue: string;
}

export interface ReportDownloadType {
  company: number;
  reportType: string;
  query?: Record<string, unknown>;
}

/**
 * Sigma
 */
export enum SigmaReportId {
  AdvertisingReport = 'tableau-ads',
  CategoryManagementReport = 'category-management-report',
  InventoryInsightsReport = 'inventory-insights-report',
  MarketScapeReport = 'tableau-marketscape',
  PaymentsReport = 'payments-report',
  PaymentOnSellThroughReport = 'payment-on-sell-through-report',
  BuyersClubInsights = 'seller-gpo-report',
}

export type SigmaReportIds = `${SigmaReportId}`;

export interface SigmaReport {
  signedUrl: string;
}
